import React from 'react';

import 'components/Dashboards/Project/Components/CustomDashboard/PinboardWidgetWrapper/Narrative/EditNarrative/editNarrative.css';
import 'components/Dashboards/Project/Components/CustomDashboard/PinboardWidgetWrapper/Narrative/EditNarrative/editNarrative.css';
import classes from 'components/Dashboards/Project/Components/CustomDashboard/PinboardWidgetWrapper/Narrative/narrative.module.scss';
import { usePinboardWidgetWrapperContext } from 'components/Dashboards/Project/Components/CustomDashboard/PinboardWidgetWrapper/context/widgetWrapperContext';

interface Props {
    value: string;
}

export const ViewNarrative = ({ value }: Props) => {
    const isEmptyNarrative = !Boolean(value) || value === ' ' || value === '<p></p>\n';
    const { isLoading } = usePinboardWidgetWrapperContext();

    if (isLoading) {
        return (
            <div className={classes.loadingWrapper}>
                Generating narrative
                <span className={classes.dots}>
                    <span className={classes.dot}>.</span>
                    <span className={classes.dot}>.</span>
                    <span className={classes.dot}>.</span>
                </span>
            </div>
        );
    }

    if (isEmptyNarrative) return null;

    return (
        <div className={classes.narrativeContainer}>
            <div dangerouslySetInnerHTML={{ __html: value }} />
        </div>
    );
};
